import z from 'zod';

export type AccessoryDetailCategoryTreeDto = {
	id: string;
	name: string;
	source: string | null;
	parent: AccessoryDetailCategoryTreeDto | null;
};

export const AccessoryDetailCategoryTreeDtoSchema: z.ZodType<AccessoryDetailCategoryTreeDto> =
	z.object({
		id: z.string(),
		name: z.string(),
		source: z.string().nullable(),
		parent: z.lazy(() => AccessoryDetailCategoryTreeDtoSchema).nullable(),
	});
